import React from "react";
import { Link as GatsbyLink } from "gatsby";
const Link = ({ children, to, activeClassName, partiallyActive, ...other }) => {
    const external = /^((\w*?:)|(\/\/))/.test(to);
    // if string begins with a word followed by : or with a double forward slash
    // then assume it's an external link and use <a>. Otherwise, use Gatsby Link.
    return (React.createElement(React.Fragment, null, external ? (React.createElement("a", { href: to, ...other }, children)) : (React.createElement(GatsbyLink, { to: to, activeClassName: activeClassName, partiallyActive: partiallyActive, ...other }, children))));
};
export default Link;
